import { useEffect, useMemo, useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useWireState, useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'

import Title from '@components/shared/Title'
import SearchTractsBar from './SearchTractsBar'
import TractsOverviewCard from './TractsOverviewCard'
import AcreageOverviewCard from './AcreageOverviewCard'
import AllTractsTable from './AllTractsTable'
import RecentTractsHeader from './RecentTractsHeader'
import RecentTractsTable from './RecentTractsTable'
import FavoriteTractsHeader from './FavoriteTractsHeader'
import FavoriteTractsTable from './FavoriteTractsTable'
import { UpsertTract } from '@components/tract/UpsertTract'
import { EditAssignedTractListModal } from '@components/tract/EditAssignedTractListModal'
import ConfirmationModal from '@components/shared/ConfirmationModal'

import '../Project.css'

export const ProjectView = () => {
    
    const { id } = useParams()
    
    const [showAdd, showHideAdd] = useState(false)
    const [showAddTract, showHideAddTract] = useState(false)
    const [editTract, setEditTract] = useState()
    
    const [query, setQuery] = useState()
    const [allTracts, setAllTracts] = useState([])
    const [showDelete, showHideDelete] = useState(false)
    
    const user = useWireValue(store.user)
    const projects = useWireValue(store.projects)
    
    // @todo currentProject doesn't exist
    const [project, setCurrentProject] = /* useWireState(store.currentProject) */ useState(null)
    
    const tracts = useWireValue(store.tracts)
    const recentTracts = useWireValue(store.recentTracts)
    const [favoriteTracts, setFavoriteTracts] = useWireState(store.favoriteTracts)
    
    const projFavoriteTract = useMemo(() => [], [])
    const favoriteUserTract = useMemo(
        () => (favoriteTracts?.length && favoriteTracts.filter(c => c.userId === user.id)) || [],
        [favoriteTracts, user.id],
    )
    const [isFavorite, setIsFavorite] = useState(false)
    const [showEditAssignTractsList, setShowEditAssignTractsList] = useState(false)
    const [isAddTract, setIsAddTract] = useState(false)
    const [tractList, setTractList] = useState([])
    const [deleteTract, setDeleteTract] = useState()
    
    // @todo
    const setFavoriteTract = () => {
        
    }
    
    useEffect(() => {
        if (!id || !projects?.length) return
        setCurrentProject(projects?.find(it => it.id === id))
    }, [id, projects])
    
    const onAddTract = useCallback(async tract => {
        await actions.createTractInProject(tract.id, project.id)
        await actions.fetchProjectById(project.id)
    }, [project])
    
    const onRemoveTract = useCallback(async tract => {
        await actions.deleteTractInProject(tract.id, project.id)
        await actions.fetchProjectById(project.id)
    }, [project])
    
    const isFavoriteTract = useCallback(tractId => {
        return favoriteTracts.some(it => it.tractId === tractId)
    }, [favoriteTracts])
    
    useEffect(() => {
        
        project?.tracts?.forEach(projTract => {
            favoriteUserTract?.forEach(tract => {
                if (tract.tractId === projTract.id)
                    projFavoriteTract.push(projTract)
            })
        })
        
        setFavoriteTract(projFavoriteTract)
        projFavoriteTract.length === 0 && setFavoriteTract([])
        
    }, [project, projFavoriteTract, favoriteUserTract])
    
    useEffect(() => {
        
        let favoriteTract = []
        
        recentTracts?.forEach(resTract => {
            favoriteTracts?.forEach(tract => {
                if (tract.tractId === resTract.tractId)
                    favoriteTract.push(resTract)
            })
        })
        
    }, [project, recentTracts, favoriteTracts])
    
    useEffect(() => {
        actions.fetchTracts()
        actions.fetchProjectById(id)
    }, [id, tractList, isAddTract])
    
    useEffect(() => {
        setAllTracts(project?.tracts ?? [])
    }, [project, recentTracts])
    
    useEffect(() => {
        actions.fetchFavoriteTracts()
        actions.fetchRecentTracts(user.id)
    }, [user.id, project, isFavorite])
    
    const addResentTract = tract => {
        
        const assigned = tract.assignedTo?.length && tract.assignedTo[0].firstName
        
        actions.createRecentTract({
            userId: user.id,
            tractId: tract.id,
            tractName: tract.name,
            assignedTo: assigned ? assigned : '',
            grossAcreage: tract.grossAcreage,
            status: tract.status,
        })
        
    }
    
    const addTractInFavorite = useCallback(async tractId => {
        
        // @todo error handling
        
        const tract = allTracts.find(it => it.id === tractId)
        
        if (!tract)
            return console.warn('addTractInFavorite tract not found', tractId)
        
        await actions.createFavoriteTract({ tractId, userId: user.id })
        
        setFavoriteTracts([...favoriteTracts, tract])
        setIsFavorite(!isFavorite)
        
    }, [allTracts, favoriteTracts])
    
    const deleteTractIsFavorite = useCallback(async tractId => {
        
        const favoriteTract = favoriteTracts.find(it => it.tractId === tractId)
        
        if (!favoriteTract)
            return console.warn('deleteTractIsFavorite tract/favorite not found')
        
        // @todo error handling
        
        await actions.deleteFavoriteTract(favoriteTract.id)
        
        setFavoriteTracts(favoriteTracts.filter(it => it.id !== favoriteTract.id))
        
    }, [favoriteTracts])
    
    const filteredAllTracts = useMemo(() => {
        
        if (!query?.length || !allTracts?.length) return allTracts
        
        return allTracts?.filter(it => it.name.toLowerCase().includes(query.toLowerCase()))
        
    }, [query, allTracts])
    
    const handleDelete = tractId => {
        actions.deleteTractInProject(tractId, id)
        const newAllTracts = allTracts?.filter(c => c.id !== tractId)
        
        if (newAllTracts) {
            setAllTracts(newAllTracts)
            setCurrentProject({
                ...project,
                tracts: newAllTracts,
            })
            actions.updateProject({
                ...project,
                tracts: newAllTracts,
            })
        }
        
        // const newRecentTracts = recentTracts.filter(c => c.tractId !== tractId)
        const recentTract = recentTracts.find(c => c.tractId === tractId)
        
        if (recentTract) {
            console.warn('wtf dunno what this does - handleDelete')
            actions.deleteRecentTract(recentTract.id)
        }
        
        // Update recent tracts through proper state management instead of direct mutation
        // actions.updateRecentTracts(newRecentTracts)
        console.warn('@todo updateRecentTracts doesn\'t exist')
        
    }
    
    return (<>
        
        <Title>{project?.name ?? 'Project'}</Title>
        
        <div className="my-3 row">
            <div className="col-2" />
            <div className="col-10">
                <button
                    className="btn btn-lg btn-primary"
                    onClick={e => {
                        // showHideAdd(!showAdd);
                        setShowEditAssignTractsList(true)
                        e.preventDefault()
                    }}>
                    Add Tract(s)
                </button>
                {''}
            </div>
        </div>
        
        <div className="row">
            
            <div className="col-2">
                <TractsOverviewCard allTracts={allTracts} />
                <AcreageOverviewCard />
            </div>
            
            <div className="col-10">
                
                <div className="row ">
                    <FavoriteTractsHeader />
                    <RecentTractsHeader />
                </div>
                
                <div className="row">
                    <div className="col-6">
                        <FavoriteTractsTable
                            allTracts={allTracts}
                            favoriteTracts={favoriteTracts}
                            deleteTractIsFavorite={deleteTractIsFavorite}
                            setEditTract={setEditTract}
                            setDeleteTract={setDeleteTract}
                            showAddTract={showAddTract}
                            showHideAddTract={showHideAddTract}
                            showHideDelete={showHideDelete} />
                    </div>
                    <div className="col-6" style={{ minHeight: '240px' }}>
                        <RecentTractsTable
                            tracts={tracts}
                            recentTracts={recentTracts}
                            addTractInFavorite={addTractInFavorite}
                            deleteTractIsFavorite={deleteTractIsFavorite}
                            setEditTract={setEditTract}
                            setDeleteTract={setDeleteTract}
                            showHideAddTract={showHideAddTract}
                            showHideDelete={showHideDelete} />
                    </div>
                </div>
                
                <SearchTractsBar
                    query={query}
                    setQuery={setQuery} />
                
                <AllTractsTable
                    allTracts={filteredAllTracts}
                    isFavoriteTract={isFavoriteTract}
                    addResentTract={addResentTract}
                    addTractInFavorite={addTractInFavorite}
                    deleteTractIsFavorite={deleteTractIsFavorite}
                    setEditTract={setEditTract}
                    setDeleteTract={setDeleteTract}
                    showHideAddTract={showHideAddTract}
                    showHideDelete={showHideDelete} />
            
            </div>
        
        </div>
        
        {showAdd && (
            <UpsertTract
                id="create-tract"
                showAdd={showAdd}
                showHideAdd={showHideAdd}
                setIsAddTract={setIsAddTract}
                project={project} />
        )}
        
        {showAddTract && (
            <UpsertTract
                id="create-tract"
                showAdd={showAddTract}
                showHideAdd={showHideAddTract}
                editTract={editTract}
                setIsAddTract={() => {}} />
        )}
        
        {showEditAssignTractsList && (
            <EditAssignedTractListModal
                setIsAddTract={setIsAddTract}
                isAddTract={isAddTract}
                assignedTracts={allTracts}
                setAssignTractsList={setAllTracts}
                setTracts={setTractList}
                setShow={setShowEditAssignTractsList}
                show={showEditAssignTractsList}
                project={project}
                onAddTract={onAddTract}
                onRemoveTract={onRemoveTract} />
        )}
        
        <ConfirmationModal
            showModal={showDelete}
            showHideModal={showHideDelete}
            title="Remove tract"
            message={`Are you sure you want to remove '${deleteTract?.name}' tract from the project '${project?.name}'`}
            onConfirm={() => {
                deleteTract && handleDelete(deleteTract.id)
            }} />
    
    </>)
    
}
